import useAsyncData from "../../../../hooks/use-async-data";
import driverService from "../../driver.service";
import DriverContractsDriversList from "./driver-contracts-drivers-list";
import DriverContractsDriversListParams from "./driver-contracts-drivers-list-params";

const useDriverContractsDriversList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<DriverContractsDriversList | null>(null);

  const load = async (
    params: DriverContractsDriversListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverContractsDriversList =
        await driverService.getDriverContractsDriversList(params, signal);

      setData(driverContractsDriversList);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverContractsDriversList;
